import script from "./SMSCampaignsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsDetails.vue?vue&type=style&index=0&id=42ce0e12&lang=scss"

const __exports__ = script;

export default __exports__